export enum RepTypeEnum {
	Agent = 1,
	Manager = 2,
	VendorManager = 3,
	Supervisor = 4,
}
